import pick from 'lodash/pick';

import {apiClient} from 'common/util/api-client';
import {Content} from 'common/types/app-api/content';

import {appApiUrl} from '../utils';

function getUrl({path, contentId, projectId}: {path?: string; contentId: string; projectId: number | string}) {
  path = path ? `/${path}` : ``;
  return appApiUrl(`contents/${contentId}${path}`, {projectId});
}

export async function favoriteContent({
  contentId,
  projectId,
  isFavorited,
}: {
  contentId: string;
  projectId: number | string;
  isFavorited: boolean;
}) {
  const url = getUrl({contentId, projectId, path: `favorite`});
  const result = await (isFavorited ? apiClient.post<Content>(url, {}) : apiClient.delete<Content>(url));
  return result;
}

export async function pinContent({
  contentId,
  projectId,
  isPinned,
}: {
  contentId: string;
  projectId: number | string;
  isPinned: boolean;
}) {
  const url = getUrl({contentId, projectId, path: `pin`});
  const result = await (isPinned ? apiClient.post<Content>(url, {}) : apiClient.delete<Content>(url));
  return result;
}

export async function updateContent({content, projectId}: {content: Content; projectId: number | string}) {
  const url = getUrl({contentId: content.id, projectId});
  const result = await apiClient.patch<Content>(url, pick(content, [`name`, `description`]));
  return result;
}

export async function deleteContent({contentId, projectId}: {contentId: string; projectId: number | string}) {
  const url = getUrl({contentId, projectId});
  const result = await apiClient.delete<{
    id: string;
  }>(url);
  return result;
}
